import { FormDynamicTextFieldInput } from "sprint-common-web";

import { CleanVideoSubtitleId } from "../../../../common/api/master-api/file-records/details/GetFileRecordDetailsResponse";
import { ContentReferenceType } from "../../../../common/types/ContentReferenceType";

export interface CreateFileRecordFormInputs {
    fileName: string;
    recordType: string;
    arrivalDate: Date;
    originator: string;
    reference: string;
    storageType: string;
    path: string;
    contentId: string;
    versionIds: string[];
    episodeId: string;
    seasonId: string;
    airlineId: string;
    contentType?: ContentReferenceType;
    isNotificationApproved: boolean;
    notes: FormDynamicTextFieldInput[];
    audioSoundtrack: string;
    audioFormat: string;
    audioResolution: string;
    audioSampleRate: string;
    audioBitrate: string;
    audioChannels: string;
    audioDuration: string;
    videoSoundtracks: string[];
    videoSubtitle: string;
    videoAspectRatio: string;
    videoAspectType: string;
    videoEncoding: boolean;
    videoFramerate: string;
    videoBitrate: string;
    videoDuration: string;
    videoResolution: string;
    videoStandard: string;
    subtitleSubtitles: string;
}

export const defaultFormInputs: CreateFileRecordFormInputs = {
    fileName: "",
    recordType: "",
    arrivalDate: new Date(),
    originator: "",
    reference: "",
    storageType: "",
    path: "",
    contentId: "",
    versionIds: [],
    episodeId: "",
    seasonId: "",
    airlineId: "",
    contentType: undefined,
    notes: [],
    audioSoundtrack: "",
    audioFormat: "",
    audioResolution: "",
    audioSampleRate: "",
    audioBitrate: "",
    audioChannels: "",
    audioDuration: "",
    videoSoundtracks: [],
    videoSubtitle: CleanVideoSubtitleId,
    videoAspectRatio: "",
    videoAspectType: "",
    videoEncoding: false,
    videoFramerate: "",
    videoBitrate: "",
    videoDuration: "",
    videoResolution: "",
    videoStandard: "",
    subtitleSubtitles: "",
    isNotificationApproved: false
};
